var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntrepreneur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 107,
    viewBox: "0 0 113 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3157_1446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.864 25.4761V71.3332C107.864 79.7753 100.965 86.6189 92.4545 86.6189H20.5454C12.0352 86.6189 5.13635 79.7753 5.13635 71.3332V25.4761H107.864ZM35.9545 56.004C33.1178 56.004 30.8182 58.2852 30.8182 61.0992V71.2897C30.8182 74.1037 33.1178 76.3849 35.9545 76.3849C38.7913 76.3849 41.0909 74.1037 41.0909 71.2897V61.0992C41.0909 58.2852 38.7913 56.004 35.9545 56.004ZM56.5 45.8135C53.6633 45.8135 51.3636 48.0947 51.3636 50.9087V71.2897C51.3636 74.1037 53.6633 76.3849 56.5 76.3849C59.3367 76.3849 61.6364 74.1037 61.6364 71.2897V50.9087C61.6364 48.0947 59.3367 45.8135 56.5 45.8135ZM77.0454 35.623C74.2087 35.623 71.9091 37.9042 71.9091 40.7183V71.2897C71.9091 74.1037 74.2087 76.3849 77.0454 76.3849C79.8822 76.3849 82.1818 74.1037 82.1818 71.2897V40.7183C82.1818 37.9042 79.8822 35.623 77.0454 35.623Z",
    fill: "#498CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.906 79.2449C53.1746 76.728 56.2599 75.7078 58.7971 76.9663C61.3344 78.2247 62.3628 81.2853 61.0942 83.8023L50.8214 104.183C49.5528 106.7 46.4675 107.72 43.9303 106.462C41.393 105.203 40.3646 102.143 41.6332 99.6259L51.906 79.2449Z",
    fill: "#498CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9059 83.8023C50.6373 81.2853 51.6657 78.2247 54.203 76.9663C56.7402 75.7078 59.8255 76.728 61.0941 79.2449L71.3669 99.6259C72.6355 102.143 71.6071 105.203 69.0698 106.462C66.5326 107.72 63.4473 106.7 62.1787 104.183L51.9059 83.8023Z",
    fill: "#498CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2727 0H102.727C108.401 0 113 4.56243 113 10.1905V15.2857H0V10.1905C0 4.56243 4.59926 0 10.2727 0Z",
    fill: "#498CCE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3157_1446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrepreneur);
export default __webpack_public_path__ + "static/media/Entrepreneur.749ec1458ae43d7b599e54b07df1d1ec.svg";
export { ForwardRef as ReactComponent };